'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$ByTfa(tfa) {
  this.Xr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.Xr = tfa;
}
export { $c_Lpresto_CredentialsView$ByTfa as $c_Lpresto_CredentialsView$ByTfa };
$p = $c_Lpresto_CredentialsView$ByTfa.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$ByTfa;
/** @constructor */
function $h_Lpresto_CredentialsView$ByTfa() {
}
export { $h_Lpresto_CredentialsView$ByTfa as $h_Lpresto_CredentialsView$ByTfa };
$h_Lpresto_CredentialsView$ByTfa.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_CredentialsView$ByTfa)) {
    var this$1 = this.Xr;
    var b = x$0.Xr;
    return ((this$1.e === b.e) && (this$1.f === b.f));
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "ByTfa";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Xr;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_CredentialsView$ByTfa(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i0)));
}
export { $isArrayOf_Lpresto_CredentialsView$ByTfa as $isArrayOf_Lpresto_CredentialsView$ByTfa };
var $d_Lpresto_CredentialsView$ByTfa = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$ByTfa, "presto.CredentialsView$ByTfa", ({
  i0: 1,
  e9: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_CredentialsView$ByTfa as $d_Lpresto_CredentialsView$ByTfa };
//# sourceMappingURL=presto.-Credentials-View$-By-Tfa.js.map
